"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
let XcPluginMigration = class XcPluginMigration {
};
const _default = XcPluginMigration;
